/* Custom-service project form. Loaded by sections/custom-service-form.liquid.
   The Service select shows the matching `[data-for="…"]` panel; hidden inputs are
   DISABLED so they stay out of the notification email. `?service=` prefills. */
(function () {
  'use strict';

  var q = new URLSearchParams(window.location.search).get('service');
  var app = document.querySelector('[data-service-app]');
  if (app) {  // Shopify Forms block: only the ?service= prefill applies (no panels; see forms_spec.json)
    if (q && window.pfFormsApp) {
      window.pfFormsApp.ready(app, function (root) {
        var el = window.pfFormsApp.control(root, 'Service');
        if (el) window.pfFormsApp.fill(el, q);
      });
    }
    return;
  }
  var form = document.getElementById('SvcForm');
  if (!form) return;
  var service = form.querySelector('[data-service]');
  var panels = form.querySelectorAll('[data-for]');
  if (!service) return;

  function toggle() {
    var want = service.value;
    Array.prototype.forEach.call(panels, function (row) {
      var on = !!want && row.getAttribute('data-for').split('|').indexOf(want) !== -1;
      row.hidden = !on;
      Array.prototype.forEach.call(row.querySelectorAll('input, select, textarea'), function (el) {
        el.disabled = !on;
      });
    });
  }

  if (q) {
    for (var i = 0; i < service.options.length; i++) {
      if (service.options[i].value === q) { service.selectedIndex = i; break; }
    }
  }
  service.addEventListener('change', toggle);
  toggle();
})();
